/** studio-shop D4, web-studio-sites D7: the bag button's drawing keeps the button opening the bag while it is shown. */
import type { RequiredParts } from '../../contract/required';
import type { ShopBagButtonState } from './contract';

export const requiredParts: RequiredParts<ShopBagButtonState> = (state) => (state.shown ? [{ part: 'button', action: 'open' }] : []);
